import * as ko from 'knockout'
import ObservableRaceKey from '@classic/Betting-v2/Model/Observables/ObservableRaceKey'
import { BettingInformation } from '@classic/Betting-v2/Model/BettingInformation'
import fieldTemplate from './field.tpl.html'
import multiFieldTemplate from './multi.field.tpl.html'
import { FieldViewModel } from './FieldViewModel'
import { MultiFieldViewModel } from './MultiFieldViewModel'

interface Params {
  raceKey: ObservableRaceKey
  bettingContext: BettingInformation
}

if (!ko.components.isRegistered('single-field')) {
  ko.components.register('single-field', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new FieldViewModel(params)
        return viewModel
      },
    },
    template: fieldTemplate,
  })
}

if (!ko.components.isRegistered('multi-field')) {
  ko.components.register('multi-field', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new MultiFieldViewModel(params)
        return viewModel
      },
    },
    template: multiFieldTemplate,
  })
}
